import { EWorkshopAndEventPageTabs } from '@configs'
import { Tabs } from 'antd'
import { useState } from 'react'
import { Text } from 'src/common'
import { EventSeoForPage } from 'src/components/workshopAndEvents/workshopEvent/seoConfigForPage/EventSeoForPage'
import { WorkShopEvent } from 'src/components/workshopAndEvents/workshopEvent/WorkShopEvent'
import styled from 'styled-components'

export const WorkShopEventPage = () => {
  const [activeTab, setActiveTab] = useState<string>(
    EWorkshopAndEventPageTabs.WORKSHOP_AND_EVENT
  )

  const tabItems = [
    {
      label: <Text>{EWorkshopAndEventPageTabs.WORKSHOP_AND_EVENT}</Text>,
      key: EWorkshopAndEventPageTabs.WORKSHOP_AND_EVENT,
      children: <WorkShopEvent activeTab={activeTab} />,
    },
    {
      label: <Text>{EWorkshopAndEventPageTabs.SEO_CONFIG}</Text>,
      key: EWorkshopAndEventPageTabs.SEO_CONFIG,
      children: <EventSeoForPage activeTab={activeTab} />,
    },
  ]
  return (
    <WorkshopEventStyle>
      <Tabs
        destroyInactiveTabPane={true}
        defaultActiveKey={EWorkshopAndEventPageTabs.WORKSHOP_AND_EVENT}
        type="card"
        size={'small'}
        items={tabItems}
        defaultChecked={true}
        activeKey={activeTab}
        onChange={(e) => {
          setActiveTab(e)
        }}
      />
    </WorkshopEventStyle>
  )
}
const WorkshopEventStyle = styled('div')(() => {
  return {
    '.ant-tabs-nav': {
      marginBottom: 0,
      paddingLeft: '1.25rem',

      '& .ant-tabs-tab': {
        borderRadius: '0.75rem 0.75rem 0 0 !important',

        '&.ant-tabs-tab-active': {
          span: {
            color: '#009BB7',
            fontWeight: '500',
          },
        },
      },
    },
  }
})
